/* eslint-disable default-case */
import {h, Component} from 'preact';
import shallowEqual from '../../utility/shallow-equal';

export default class AssociatedUser extends Component {
	constructor({id, firstName, lastName, email, endDate}) {
		super();
		this.state = {
			id,
			firstName,
			lastName,
			email,
			endDate,
			renderStatus: 'INITIAL'
		};
		this.handleDeleteClick = this.handleDeleteClick.bind(this);
	}

	handleDeleteClick(deletionEvent) {
		deletionEvent.preventDefault();
		const bpid = window.BPID;
		fetch(`/organizations/${bpid}/associated-users/${this.state.id}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			credentials: 'include'
		}).then(response => {
			if (!response.ok) {
				// we will handle this later
				throw new Error(`Request rejected with status ${response.status}`);
			}
			return response.json();
		}).then(data => {
			this.setState({
				renderStatus: data.status
			});
		}).catch(error => console.log('Error:', error));
	}

	shouldComponentUpdate(properties, state) {
		return !(shallowEqual(properties, this.props) && shallowEqual(state, this.state));
	}

	render(properties, state) {
		switch (state.renderStatus) {
			case 'OK':
				return <tr><td colspan="4" class="c-table__data">
					<p>{state.email} is not associated with this organization any more.</p>
				</td></tr>;
			case 'FAILED':
				return <tr>
					<td class="c-table__data c-table__data--vertical-align-middle">
						<div class="c-table__feedback-wrapper"><p class="c-table__feedback-message">Right now we can not remove this association. Removing associations should work again in a few minutes.</p></div>
						{state.firstName} {state.lastName}
					</td>
					<td class="c-table__data c-table__data--vertical-align-middle">
						{state.email}
					</td>
					<td class="c-table__data c-table__data--vertical-align-middle">{state.endDate}</td>
					<td class="c-table__data">
						<button class="c-button c-button--inverse c-button--small" onClick={this.handleDeleteClick} id={state.id}>Remove</button>
					</td>
				</tr>;
			case 'INITIAL':
				return <tr>
					<td class="c-table__data c-table__data--vertical-align-middle">{state.firstName} {state.lastName}</td>
					<td class="c-table__data c-table__data--vertical-align-middle">{state.email}</td>
					<td class="c-table__data c-table__data--vertical-align-middle u-whitespace-nowrap">{state.endDate}</td>
					<td class="c-table__data">
						<button class="c-button c-button--inverse c-button--small" onClick={this.handleDeleteClick} id={state.id} data-track="click_associated_users" data-track-category="Other access methods" data-track-action="Button click" data-track-label="Remove Association" data-track-context="Associated users">Remove</button>
					</td>
				</tr>;
		}
	}
}
